import React from 'react';
import { Typography } from '@forgeglobal/design-framework';
import Selector, { SelectorProps } from '@tcs/common/components/atoms/Selector';
import { isEmpty } from 'lodash';

type Props = Omit<SelectorProps, 'labelVariant'>;

const TitleSelector = (props: Props) => {
  const { items } = props;
  const variant = 'h4';
  if (isEmpty(items)) return null;

  if (items.length === 1) {
    return <Typography variant={variant}>{items[0].listItem}</Typography>;
  }

  return <Selector labelVariant={variant} {...props} />;
};

export default TitleSelector;
